module.exports = __webpack_public_path__ + "static/media/like.0d09859a.svg";